var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showForm,
          expression: "showForm"
        }
      ],
      staticClass: "new-attraction-container"
    },
    [
      _c("h1", { staticClass: "main-heading" }, [
        _vm._v("\n        Új Vonzerő felvétele\n    ")
      ]),
      _c("a-divider"),
      _c(
        "a-steps",
        { attrs: { current: _vm.current, status: _vm.stepStatus } },
        _vm._l(_vm.steps, function(item, index) {
          return _c(
            "a-step",
            { key: item.title, attrs: { title: item.title } },
            [
              index === 2 && _vm.isAttractionSaving
                ? _c("a-icon", {
                    attrs: { slot: "icon", type: "loading" },
                    slot: "icon"
                  })
                : _vm._e()
            ],
            1
          )
        }),
        1
      ),
      _c(
        "a-form",
        {
          staticClass: "new-attraction-form",
          attrs: { form: _vm.form, layout: "vertical" }
        },
        [
          _vm.current === 0
            ? [
                _c("h2", [
                  _vm._v(
                    "\n                Kötelező adatok megadása a vonzerőhöz.\n            "
                  )
                ]),
                _c(
                  "a-form-item",
                  { attrs: { label: "Vonzerő neve" } },
                  [
                    _c("a-textarea", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "name",
                            {
                              rules: [
                                {
                                  required: true,
                                  preserve: true,
                                  message: "Kérjük töltse ki!"
                                },
                                {
                                  max: _vm.characterCounts.name.max,
                                  message:
                                    "Maximum " +
                                    _vm.characterCounts.name.max +
                                    " karakter engedélyezett."
                                }
                              ],
                              validateTrigger: ["blur", "keyup"]
                            }
                          ],
                          expression:
                            "[\n                        'name',\n                        {\n                            rules: [\n                                {\n                                  required: true,\n                                  preserve: true,\n                                  message: 'Kérjük töltse ki!'\n                                },\n                                {\n                                  max: characterCounts.name.max,\n                                  message: 'Maximum ' + characterCounts.name.max + ' karakter engedélyezett.',\n                                }\n                            ],\n                            validateTrigger: ['blur', 'keyup']\n                        }\n                    ]"
                        }
                      ],
                      attrs: {
                        maxLength: 25000,
                        autoSize: { minRows: 2 },
                        placeholder: "Vonzerő neve"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      label:
                        "A vonzerő/létesítmény általános bemutatása, rövid leírása, kiemelendő értékei, története, fontosabb célcsoportjai stb."
                    }
                  },
                  [
                    _c("Wysiwyg", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "shortDescription",
                            {
                              rules: [
                                {
                                  required: true,
                                  preserve: true,
                                  transform: function(value) {
                                    return _vm.stripTags(value)
                                  },
                                  min: _vm.characterCounts.shortDescription.min,
                                  max: _vm.characterCounts.shortDescription.max,
                                  message:
                                    "Kérjük töltse ki! A leírás hosszának " +
                                    _vm.characterCounts.shortDescription.min +
                                    " és " +
                                    _vm.characterCounts.shortDescription.max +
                                    " között kell lennie."
                                }
                              ],
                              validateTrigger: ["blur", "keyup"]
                            }
                          ],
                          expression:
                            "[\n                        'shortDescription',\n                        {\n                            rules: [\n                                {\n                                  required: true,\n                                  preserve: true,\n                                  transform: (value) => {\n                                    return stripTags(value);\n                                  },\n                                  min: characterCounts.shortDescription.min,\n                                  max: characterCounts.shortDescription.max,\n                                  message: 'Kérjük töltse ki! A leírás hosszának ' + characterCounts.shortDescription.min\n                                  + ' és ' + characterCounts.shortDescription.max + ' között kell lennie.',\n                                }\n                            ],\n                            validateTrigger: ['blur', 'keyup']\n                        }\n                    ]"
                        }
                      ],
                      attrs: {
                        height: 100,
                        placeholder:
                          "A vonzerő/létesítmény általános bemutatása, rövid leírása, kiemelendő értékei, története, fontosabb célcsoportjai stb."
                      },
                      on: {
                        keyup: _vm.characterCount,
                        change: _vm.characterCount
                      }
                    }),
                    _c("div", { staticClass: "character-count" }, [
                      _c(
                        "strong",
                        {
                          class: {
                            invalid:
                              _vm.characterCounts.shortDescription.valid ===
                              false,
                            valid:
                              _vm.characterCounts.shortDescription.valid ===
                              true
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.characterCounts.shortDescription.current
                              ) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(
                        "\n\n                    / " +
                          _vm._s(_vm.characterCounts.shortDescription.min) +
                          " - " +
                          _vm._s(_vm.characterCounts.shortDescription.max) +
                          "\n                "
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  { attrs: { label: "Irányítószám" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "address/zipCode/id",
                              {
                                rules: [
                                  {
                                    required: true,
                                    whitespace: true,
                                    message: "Kérjük töltse ki!",
                                    type: "integer"
                                  }
                                ],
                                validateTrigger: ["blur", "keyup"]
                              }
                            ],
                            expression:
                              "[\n                        'address/zipCode/id',\n                        {\n                            rules: [\n                                {\n                                required: true,\n                                whitespace: true,\n                                message: 'Kérjük töltse ki!',\n                                type: 'integer'\n                              },\n                            ],\n                            validateTrigger: ['blur','keyup']\n                        }\n                    ]"
                          }
                        ],
                        style: { width: "100%" },
                        attrs: {
                          placeholder: "Kezdjen gépelni",
                          showSearch: "",
                          showArrow: false,
                          defaultActiveFirstOption: false,
                          filterOption: false,
                          notFoundContent: _vm.zipCodeOptionsLoading
                            ? undefined
                            : null
                        },
                        on: {
                          search: _vm.zipCodeAutoComplete,
                          change: _vm.zipCodeChange,
                          dropdownVisibleChange: _vm.zipCodeAutoComplete
                        }
                      },
                      [
                        _vm.zipCodeOptionsLoading
                          ? _c("a-spin", {
                              attrs: { slot: "notFoundContent", size: "small" },
                              slot: "notFoundContent"
                            })
                          : _vm._e(),
                        _vm._l(_vm.zipCodeOptions, function(option) {
                          return _c(
                            "a-select-option",
                            { key: option.id, attrs: { value: option.id } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.code) +
                                  "\n                    "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  { attrs: { label: "Település neve" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "address/city/id",
                              {
                                rules: [
                                  {
                                    required: true,
                                    whitespace: true,
                                    message: "Kérjük töltse ki!",
                                    type: "integer"
                                  }
                                ],
                                validateTrigger: ["blur", "keyup"]
                              }
                            ],
                            expression:
                              "[\n                        'address/city/id',\n                        {\n                            rules: [\n                                {\n                                required: true,\n                                whitespace: true,\n                                message: 'Kérjük töltse ki!',\n                                type: 'integer'\n                              },\n                            ],\n                            validateTrigger: ['blur','keyup']\n                        }\n                    ]"
                          }
                        ],
                        style: { width: "100%" },
                        attrs: {
                          placeholder: "Töltse ki az irányítószám mezőt!",
                          showArrow: false,
                          disabled: !_vm.cityOptions.length,
                          defaultActiveFirstOption: true,
                          filterOption: false,
                          notFoundContent: _vm.zipCodeOptionsLoading
                            ? undefined
                            : null
                        },
                        on: { change: _vm.cityChange }
                      },
                      [
                        _vm.zipCodeOptionsLoading
                          ? _c("a-spin", {
                              attrs: { slot: "notFoundContent", size: "small" },
                              slot: "notFoundContent"
                            })
                          : _vm._e(),
                        _vm._l(_vm.cityOptions, function(option) {
                          return _c(
                            "a-select-option",
                            { key: option.id, attrs: { value: option.id } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.name) +
                                  "\n                    "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  { attrs: { label: "Közterület neve" } },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "address/address",
                            {
                              rules: [
                                {
                                  required: !_vm.isChecked(
                                    "address/addressNotRelevant"
                                  ),
                                  whitespace: true,
                                  message: "Kérjük töltse ki!"
                                },
                                {
                                  max:
                                    _vm.characterCounts["address/address"].max,
                                  message:
                                    "Maximum " +
                                    _vm.characterCounts["address/address"].max +
                                    " karakter engedélyezett."
                                }
                              ],
                              validateTrigger: ["blur", "keyup"]
                            }
                          ],
                          expression:
                            "[\n                        'address/address',\n                        {\n                            rules: [\n                                {\n                                  required: !isChecked('address/addressNotRelevant'),\n                                  whitespace: true,\n                                  message: 'Kérjük töltse ki!'\n                                },\n                                {\n                                  max: characterCounts['address/address'].max,\n                                  message: 'Maximum ' + characterCounts['address/address'].max + ' karakter engedélyezett.',\n                                }\n                            ],\n                            validateTrigger: ['blur','keyup']\n                        }\n                    ]"
                        }
                      ],
                      attrs: {
                        maxLength: 25000,
                        disabled: _vm.isChecked("address/addressNotRelevant"),
                        placeholder: "Kérjük beírni (betűkkel)"
                      }
                    }),
                    _c(
                      "a-checkbox",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "address/addressNotRelevant",
                              {
                                rules: [
                                  {
                                    required: false
                                  }
                                ]
                              }
                            ],
                            expression:
                              "[\n                    'address/addressNotRelevant',\n                    {\n                        rules: [{\n                            required: false\n                        }]\n                    }\n                ]"
                          }
                        ],
                        attrs: {
                          checked: _vm.isChecked("address/addressNotRelevant")
                        },
                        on: {
                          change: function(event) {
                            return _vm.relevancyCheckboxChange(
                              event,
                              "address/address"
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    Nem releváns\n                "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      label: "Közterület típusa (utca, tér, út, dűlő stb.)"
                    }
                  },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "address/addressType",
                            {
                              rules: [
                                {
                                  required: !_vm.isChecked(
                                    "address/addressTypeNotRelevant"
                                  ),
                                  whitespace: true,
                                  message: "Kérjük töltse ki!"
                                },
                                {
                                  max:
                                    _vm.characterCounts["address/addressType"]
                                      .max,
                                  message:
                                    "Maximum " +
                                    _vm.characterCounts["address/addressType"]
                                      .max +
                                    " karakter engedélyezett."
                                }
                              ],
                              validateTrigger: ["blur", "keyup"]
                            }
                          ],
                          expression:
                            "[\n                        'address/addressType',\n                        {\n                            rules: [\n                                {\n                                  required: !isChecked('address/addressTypeNotRelevant'),\n                                  whitespace: true,\n                                  message: 'Kérjük töltse ki!'\n                                },\n                                {\n                                  max: characterCounts['address/addressType'].max,\n                                  message: 'Maximum ' + characterCounts['address/addressType'].max + ' karakter engedélyezett.',\n                                }\n                            ],\n                            validateTrigger: ['blur','keyup']\n                        }\n                    ]"
                        }
                      ],
                      attrs: {
                        maxLength: 25000,
                        disabled: _vm.isChecked(
                          "address/addressTypeNotRelevant"
                        ),
                        placeholder: "Kérjük beírni (betűkkel)"
                      }
                    }),
                    _c(
                      "a-checkbox",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "address/addressTypeNotRelevant",
                              {
                                rules: [
                                  {
                                    required: false
                                  }
                                ]
                              }
                            ],
                            expression:
                              "[\n                    'address/addressTypeNotRelevant',\n                    {\n                        rules: [{\n                            required: false\n                        }]\n                    }\n                ]"
                          }
                        ],
                        attrs: {
                          checked: _vm.isChecked(
                            "address/addressTypeNotRelevant"
                          )
                        },
                        on: {
                          change: function(event) {
                            return _vm.relevancyCheckboxChange(
                              event,
                              "address/addressType"
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    Nem releváns\n                "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm._v(
                          "\n          Házszám/helyrajzi szám\n          "
                        ),
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              title:
                                "Itt a házszámon kívül más is beírható (pl. helyrajzi szám vagy más egyéb, pontos azonosító, ami az adott ingatlan helyét pontosan meghatározza). Ha nincs ilyen pontos azonosító szám a címhez, akkor kérjük a mezőt üresen hagyni."
                            }
                          },
                          [
                            _c("a-icon", {
                              attrs: { type: "question-circle-o" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "address/addressNumber",
                            {
                              rules: [
                                {
                                  required: !_vm.isChecked(
                                    "address/addressNumberNotRelevant"
                                  ),
                                  whitespace: true,
                                  message: "Kérjük töltse ki!"
                                },
                                {
                                  max:
                                    _vm.characterCounts["address/addressNumber"]
                                      .max,
                                  message:
                                    "Maximum " +
                                    _vm.characterCounts["address/addressNumber"]
                                      .max +
                                    " karakter engedélyezett."
                                }
                              ],
                              validateTrigger: ["blur", "keyup"]
                            }
                          ],
                          expression:
                            "[\n                        'address/addressNumber',\n                        {\n                            rules: [\n                                {\n                                  required: !isChecked('address/addressNumberNotRelevant'),\n                                  whitespace: true,\n                                  message: 'Kérjük töltse ki!'\n                                },\n                                {\n                                  max: characterCounts['address/addressNumber'].max,\n                                  message: 'Maximum ' + characterCounts['address/addressNumber'].max + ' karakter engedélyezett.',\n                                }\n                            ],\n                            validateTrigger: ['blur','keyup']\n                        }\n                    ]"
                        }
                      ],
                      attrs: {
                        maxLength: 25000,
                        disabled: _vm.isChecked(
                          "address/addressNumberNotRelevant"
                        ),
                        placeholder: "Kérjük beírni (számokkal, betűkkel)"
                      }
                    }),
                    _c(
                      "a-checkbox",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "address/addressNumberNotRelevant",
                              {
                                rules: [
                                  {
                                    required: false
                                  }
                                ]
                              }
                            ],
                            expression:
                              "[\n                    'address/addressNumberNotRelevant',\n                    {\n                        rules: [{\n                            required: false\n                        }]\n                    }\n                ]"
                          }
                        ],
                        attrs: {
                          checked: _vm.isChecked(
                            "address/addressNumberNotRelevant"
                          )
                        },
                        on: {
                          change: function(event) {
                            return _vm.relevancyCheckboxChange(
                              event,
                              "address/addressNumber"
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    Nem releváns\n                "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm._v(
                          "\n          A vonzerőt üzemeltető szervezet központi e-mail címe  \n          "
                        ),
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              title:
                                "Amennyiben nem rendelkezik e-mail címmel az objektum, úgy kérjük, adja meg a Tourinform iroda központi e-mail címét!"
                            }
                          },
                          [
                            _c("a-icon", {
                              attrs: { type: "question-circle-o" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "centralContact/email",
                            {
                              rules: [
                                {
                                  required: true,
                                  whitespace: true,
                                  type: "email",
                                  message:
                                    "Kérjük a megfelelő formátumban töltse ki!"
                                },
                                {
                                  max:
                                    _vm.characterCounts["centralContact/email"]
                                      .max,
                                  message:
                                    "Maximum " +
                                    _vm.characterCounts["centralContact/email"]
                                      .max +
                                    " karakter engedélyezett."
                                }
                              ],
                              validateTrigger: ["blur", "keyup"]
                            }
                          ],
                          expression:
                            "[\n                        'centralContact/email',\n                        {\n                            rules: [\n                                {\n                                  required: true,\n                                  whitespace: true,\n                                  type: 'email',\n                                  message: 'Kérjük a megfelelő formátumban töltse ki!'\n                                },\n                                {\n                                  max: characterCounts['centralContact/email'].max,\n                                  message: 'Maximum ' + characterCounts['centralContact/email'].max + ' karakter engedélyezett.',\n                                }\n                            ],\n                            validateTrigger: ['blur','keyup']\n                        }\n                    ]"
                        }
                      ],
                      attrs: {
                        type: "email",
                        maxLength: 25000,
                        placeholder: "Kérjük az e-mail címet beírni!"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm._v(
                          "\n          A vonzerő GPS koordinátája: szélességi fok\n\n          "
                        ),
                        _c(
                          "a-tooltip",
                          { attrs: { title: _vm.coordinateTooltipLatitude } },
                          [
                            _c("a-icon", {
                              attrs: { type: "question-circle-o" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "address/lat",
                            {
                              rules: [
                                {
                                  required: true,
                                  whitespace: true,
                                  pattern: /^4([-+]?)([\d]{1})(((\.)(\d+)))$/g,
                                  message: "A koordináták formátuma helytelen!"
                                },
                                {
                                  type: "float",
                                  message:
                                    "Kérjük adjon meg valós GPS koordinátákat!",
                                  transform: function(value) {
                                    value = parseFloat(value)

                                    return isNaN(value) ? null : value
                                  },
                                  min: 45.72,
                                  max: 48.6
                                }
                              ],
                              validateTrigger: ["blur", "keyup"]
                            }
                          ],
                          expression:
                            "[\n                        'address/lat',\n                        {\n                            rules: [\n                                {\n                                  required: true,\n                                  whitespace: true,\n                                  pattern: /^4([-+]?)([\\d]{1})(((\\.)(\\d+)))$/g,\n                                  message: 'A koordináták formátuma helytelen!'\n                                },\n                                {\n                                  type: 'float',\n                                  message: 'Kérjük adjon meg valós GPS koordinátákat!',\n                                  transform: (value) => {\n                                    value = parseFloat(value);\n\n                                    return isNaN(value) ? null: value;\n                                  },\n                                  min: 45.72,\n                                  max: 48.60\n                                }\n                                ],\n                            validateTrigger: ['blur','keyup']\n                        }\n                    ]"
                        }
                      ],
                      attrs: {
                        maxLength: 25000,
                        placeholder:
                          "Kérjük a koordinátát az alábbi formátumban adja meg: 47.507346"
                      },
                      on: {
                        change: function(event) {
                          return _vm.formatCoordinate(
                            event.target.value,
                            "address/lat"
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "span",
                      { attrs: { slot: "label" }, slot: "label" },
                      [
                        _vm._v(
                          "\n        A vonzerő GPS koordinátája: hosszúsági fok\n\n        "
                        ),
                        _c(
                          "a-tooltip",
                          { attrs: { title: _vm.coordinateTooltipLongitude } },
                          [
                            _c("a-icon", {
                              attrs: { type: "question-circle-o" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "address/long",
                            {
                              rules: [
                                {
                                  required: true,
                                  whitespace: true,
                                  pattern: /^(1|2)(([-+]?)([\d]{1})((\.)(\d+))?)$/g,
                                  message: "A koordináták formátuma helytelen!"
                                },
                                {
                                  type: "float",
                                  message:
                                    "Kérjük adjon meg valós GPS koordinátákat!",
                                  transform: function(value) {
                                    value = parseFloat(value)

                                    return isNaN(value) ? null : value
                                  },
                                  min: 16.1,
                                  max: 23
                                }
                              ],
                              validateTrigger: ["blur", "keyup"]
                            }
                          ],
                          expression:
                            "[\n                        'address/long',\n                        {\n                            rules: [\n                                {\n                                  required: true,\n                                  whitespace: true,\n                                  pattern: /^(1|2)(([-+]?)([\\d]{1})((\\.)(\\d+))?)$/g,\n                                  message: 'A koordináták formátuma helytelen!'\n                                },\n                                {\n                                  type: 'float',\n                                  message: 'Kérjük adjon meg valós GPS koordinátákat!',\n                                  transform: (value) => {\n                                    value = parseFloat(value);\n\n                                    return isNaN(value) ? null: value;\n                                  },\n                                  min: 16.10,\n                                  max: 23\n                                }],\n                            validateTrigger: ['blur','keyup']\n                        }\n                    ]"
                        }
                      ],
                      attrs: {
                        maxLength: 25000,
                        placeholder:
                          "Kérjük a koordinátát az alábbi formátumban adja meg: 19.046610!"
                      },
                      on: {
                        change: function(event) {
                          return _vm.formatCoordinate(
                            event.target.value,
                            "address/long"
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("a-divider"),
                _c(
                  "div",
                  { staticClass: "steps-navigation-buttons" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.stepToCategories }
                      },
                      [
                        _vm._v(
                          "\n                    Tovább\n\n                    "
                        ),
                        _c("a-icon", { attrs: { type: "right" } })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.current === 1
            ? [
                _c("h2", [
                  _vm._v(
                    "\n                Kategória kiválasztása\n            "
                  )
                ]),
                _c(
                  "a-form-item",
                  { attrs: { label: "Kategória" } },
                  [
                    _c(
                      "a-radio-group",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "group/id",
                              {
                                rules: [
                                  {
                                    required: true,
                                    preserve: true,
                                    message: "Kérjük válasszon!",
                                    type: "integer"
                                  }
                                ],
                                validateTrigger: "blur"
                              }
                            ],
                            expression:
                              "['group/id',{\n            rules:\n            [\n              {\n                required: true,\n                preserve: true,\n                message: 'Kérjük válasszon!',\n                type: 'integer'\n              }\n            ],\n                validateTrigger: 'blur'\n            }\n          ]"
                          }
                        ]
                      },
                      _vm._l(_vm.categories, function(category) {
                        return _c(
                          "a-radio-button",
                          { key: category.id, attrs: { value: category.id } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(category.label) +
                                "\n\n                        "
                            ),
                            _c("a-icon", { attrs: { type: category.icon } })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c("a-divider"),
                _c(
                  "div",
                  { staticClass: "steps-navigation-buttons" },
                  [
                    _c(
                      "a-button-group",
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.stepBackward }
                          },
                          [
                            _vm._v(
                              "\n                        Vissza\n\n                        "
                            ),
                            _c("a-icon", { attrs: { type: "left" } })
                          ],
                          1
                        ),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.stepForward($event, ["group/id"])
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Tovább\n\n                        "
                            ),
                            _c("a-icon", { attrs: { type: "right" } })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.current === 2
            ? [
                _c("h2", [
                  _vm._v("\n                Véglegesítés\n            ")
                ]),
                _c(
                  "div",
                  { staticClass: "attraction-details-holder" },
                  [
                    _c("a-divider", { attrs: { orientation: "left" } }, [
                      _vm._v(
                        "\n                    Vonzerő neve:\n                "
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.formFields.name) +
                          "\n                "
                      )
                    ]),
                    _vm.formFields["address/city/name"]
                      ? [
                          _c("a-divider", { attrs: { orientation: "left" } }, [
                            _vm._v(
                              "\n                        Vonzerő települése:\n                    "
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.formFields["address/city/name"]) +
                                "\n                    "
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm.groupElement
                      ? [
                          _c("a-divider", { attrs: { orientation: "left" } }, [
                            _vm._v(
                              "\n                        Vonzerő kategóriája:\n                    "
                            )
                          ]),
                          _c(
                            "p",
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.groupElement.label) +
                                  "\n\n                        "
                              ),
                              _c("a-icon", {
                                attrs: { type: _vm.groupElement.icon }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _c("a-divider"),
                _c(
                  "div",
                  { staticClass: "steps-navigation-buttons" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.stepBackward }
                      },
                      [
                        _vm._v(
                          "\n                    Vissza\n\n                    "
                        ),
                        _c("a-icon", { attrs: { type: "left" } })
                      ],
                      1
                    ),
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type: "primary",
                          loading: _vm.isAttractionSaving
                        },
                        on: { click: _vm.stepFinal }
                      },
                      [
                        _vm._v(
                          "\n                    Mentés és tovább\n\n                    "
                        ),
                        _c("a-icon", { attrs: { type: "right" } })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.current === 3
            ? [
                _c("h2", [
                  _vm._v(
                    "\n                Vonzerő sikeresen felvéve\n            "
                  )
                ]),
                _c("a-divider"),
                _c(
                  "div",
                  { staticClass: "steps-navigation-buttons" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "neta-list" } } },
                      [
                        _c(
                          "a-button",
                          { attrs: { type: "primary" } },
                          [
                            _vm._v(
                              "\n                        Vissza a listához\n\n                        "
                            ),
                            _c("a-icon", { attrs: { type: "table" } })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "neta-basic-attraction-attraction-data-form",
                            params: { id: _vm.attractionId }
                          }
                        }
                      },
                      [
                        _c(
                          "a-button",
                          { attrs: { type: "primary" } },
                          [
                            _vm._v(
                              "\n                        Tovább a szerkesztésre\n\n                        "
                            ),
                            _c("a-icon", { attrs: { type: "edit" } })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }